export default __webpack_public_path__ + "static/wateringTheFlowers-ca26e353b1eea3e477cc582faf54a23d.png";